import React, { useState } from "react";
import { mutate } from "swr";

import { Grid, IconButton, Tooltip, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { editObjectData } from "@aclymatepackages/array-immutability-helpers";
import { TextField } from "@aclymatepackages/atoms";

import ScopeThreeCategorySelect from "./ScopeThreeCategorySelect";
import OpenAiVendorCategorization from "./OpenAiVendorCategorization";

import { newVendorRelationship } from "../../../helpers/utils/apiCalls";
import useEmissionsContext from "../../../helpers/contexts/emissions";
import { useAccountData } from "../../../helpers/firebase";

const NewVendorForm = ({
  setVendor,
  setShowNewVendorForm,
  transactionSubcategory
}) => {
  const { vendors } = useEmissionsContext();
  const [accountData] = useAccountData();

  const [newVendor, setNewVendor] = useState({ id: "new-vendor" });

  const editNewVendor = (field) => (value) =>
    editObjectData(setNewVendor, field, value);

  const {
    id: existingVendorId,
    name = "",
    naicsCode,
    scopeThreeCategory
  } = newVendor;

  const isDuplicateVendorName = !!vendors.find(
    (vendor) => vendor.name.toLowerCase() === name.toLowerCase()
  );

  const isButtonDisabled =
    isDuplicateVendorName ||
    !name ||
    (transactionSubcategory === "spend-based" && !naicsCode);

  const onNewVendorSave = async () => {
    setShowNewVendorForm(false);

    const { id: buyerId, name: buyerName } = accountData;
    const { vendorName, vendorId } = await newVendorRelationship({
      ...newVendor,
      emissionCategory: transactionSubcategory,
      ...(existingVendorId !== "new-vendor" && { vendorId: existingVendorId }),
      vendorName: name,
      buyerId,
      buyerName,
      source: "manual-entry"
    });

    mutate("vendor-relationships");

    return setVendor({
      ...newVendor,
      name: vendorName,
      vendorId,
      emissionCategory: transactionSubcategory,
      archived: false,
      id: vendorId
    });
  };

  return (
    <Grid container spacing={2} direction="column">
      <Grid item>
        <TextField
          label="Vendor Name"
          value={name}
          setValue={editNewVendor("name")}
          helperText="Please use the full vendor name (e.g. United Airlines instead of United)"
        />
      </Grid>
      <>
        {transactionSubcategory === "spend-based" && (
          <>
            <Grid item>
              <OpenAiVendorCategorization
                editVendor={editNewVendor}
                naicsCode={naicsCode}
              />
            </Grid>
            <Grid item>
              <ScopeThreeCategorySelect
                scopeThreeCategory={scopeThreeCategory}
                setScopeThreeCategory={editNewVendor("scopeThreeCategory")}
              />
            </Grid>
          </>
        )}
      </>
      <Grid item container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Tooltip title="Back to select a vendor">
            <IconButton onClick={() => setShowNewVendorForm(false)}>
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item>
          <Button
            disabled={isButtonDisabled}
            variant="contained"
            color="primary"
            onClick={onNewVendorSave}
          >
            Add Vendor
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default NewVendorForm;
